// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3dHXK","detailsBorder":"styles_detailsBorder__38XuL"};